// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"b2c5dcb1","501":"a0b58841","720":"c45c1563","737":"24d20940"}[chunkId] + ".chunk.js";
};